import { plural } from '../../../utils/plural.ts';

export interface MonitoringPatientCounts {
    notificationPatients: number;
    messagePatients: number;
}

// Plain sum on purpose: a patient with open notifications and open messages is two tasks.
export function monitoringBadgeCount({
    notificationPatients,
    messagePatients
}: MonitoringPatientCounts): number {
    return notificationPatients + messagePatients;
}

export function patientsAndEventsLabel(
    patients: number,
    events: number,
    eventNoun: string
): string {
    return `${plural(patients, 'patient')} · ${plural(events, eventNoun)}`;
}

export const CLOSED_WINDOW = 'resolved in the last 24 hours';

export function resolvedPatientsLabel(patients: number): string {
    return `${plural(patients, 'patient')} ${CLOSED_WINDOW}`;
}

export function notificationPatientsBadgeLabel(count: number): string {
    return `${plural(count, 'patient')} with open notifications`;
}

export function messagePatientsBadgeLabel(count: number): string {
    return `${plural(count, 'patient')} with messages to review`;
}

export function monitoringTasksBadgeLabel(count: number): string {
    return `${plural(count, 'patient task')} in Monitoring`;
}
